import {
  _primaryControls,
  _selectorControls,
  _increment,
  production_type,
  job_no,
  module_no,
  drawing_no,
  description,
  material_code,
  amount,
  withdrawn_amount,
  purchased_amount,
  unit,
  status,
  heat_treatment,
  surface_treatment,
  target_date,
  remarks,
  leadTime,
} from '@/table/Job/SubJob/base';
import useSubJob from '@/use/useSubJob';

const {
  translateSubJobStatus, statusClassMap,
} = useSubJob();

function getStatus(
  overallStatus: string,
  computedStatus: string,
  processStatus: string | null = null,
  assemblyStatus: string | null = null,
) {
  if (overallStatus === 'REVISE' || overallStatus === 'MODIFY') return overallStatus;
  if (overallStatus === 'IN_PROGRESS') return 'OUTSOURCE';
  if (computedStatus === 'DONE') return computedStatus;
  if (computedStatus === 'STAND_BY') return 'READY_ASSEMBLY';
  if (processStatus === 'OUTSOURCE') {
    if (computedStatus === 'PENDING') return 'OUTSOURCE';
    return computedStatus;
  }
  if (assemblyStatus !== null) return assemblyStatus;
  return computedStatus;
}

export default {
  types: {
    _primaryControls,
    _selectorControls,
    _increment,
    production_type,
    job_no,
    module_no,
    drawing_no,
    description,
    material_code,
    amount,
    withdrawn_amount,
    purchased_amount,
    unit,
    status: {
      ...status,
      filter: (val: string, row: any) => translateSubJobStatus(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      class: {
        text: (val: string, row: any) => statusClassMap(getStatus(row.item.status, row.item.computed_status, row.item.process_status, row.item.assembly_status)),
      },
    },
    heat_treatment,
    surface_treatment,
    target_date,
    remarks,
    leadTime,
  },
  sortable: [
    'production_type',
    'job_no',
    'module_no',
    'drawing_no',
    'description',
    'material_code',
    'amount',
    'withdrawn_amount',
    'purchased_amount',
    'unit',
    'status',
    'heat_treatment',
    'surface_treatment',
    'target_date',
  ],
};
